import { Injectable } from "@angular/core";
@Injectable()
export class ScrollingService {
  public index = 0;
  public reset() {
    this.index = 0;
  }
}
